/* global KruxSasHelper */
/* global CsnImpressionTracker */

(function ($, w, krux) {
    "use strict";
    function getSasKruxTags() {
        if (krux) {
            let kr = krux();
            let kruxTagsValue = kr.getSasTags();
            let kruxTags = '/' + kruxTagsValue;

            let gaId = kr.getGaTags();

            if (gaId) {
                kruxTags += '/gaclientId=' + gaId;
            }
            return kruxTags;
        } else {
            if (console) {
                console.warn('KruxSasHelper not loaded');
                return "";
            }
        }
    }

    function appendTracker(elm, fcid) {
        if (elm == null || fcid == null)
            return;
        let kruxTags = getSasKruxTags();
        let random = Math.round(Math.random() * 100000000);
        let imgContent = '<img class="gc-imp-tracker" src="//mm.carsales.com.au/carsales/iserver/fcid=' + fcid + '/site=allpoints/area=impressiontracker/size=1x1/viewid=' + random + '/random=' + random + kruxTags + '"style="display:none;"></img>';
        elm.append(imgContent);
    }

    w.CsnImpressionTracker = {
        track: function(scopeSelector) {
            scopeSelector = scopeSelector || 'body';
            let $scopeElement = $(scopeSelector);

            $scopeElement.find('[csn-impression-tracker]').each(function(index, item) {
                let $item = $(item);
                const isVisible = $item.is(":visible");
                if (!isVisible) return;
                let eventType = $item.attr('csn-track-event') || 'load';
                let fcid = $item.attr('csn-impression-tracker');
                if (eventType === 'load') {
                    appendTracker($item, fcid);
                } else if (eventType === 'click') {
                    $item.on('click',
                        function() {
                            appendTracker($item, fcid);
                        });
                }

                $item.removeAttr('csn-impression-tracker');
            });
        }
    };

    $(function() {
        CsnImpressionTracker.track();
    });
})(jQuery, window, KruxSasHelper);